/* =========================================================
 * Dorm Concierge — Shopify-embeddable widget
 * Vanilla JS, no dependencies. Mounts into any element with
 * class .dc-app and a data-dc-endpoint attribute.
 * ========================================================= */
(function (global) {
  "use strict";

  var MAX_FILES = 5;
  var MAX_FILE_BYTES = 10 * 1024 * 1024; // 10 MB per file
  var ACCEPTED_TYPES = [
    "image/jpeg",
    "image/png",
    "image/heic",
    "image/heif",
    "image/webp",
    "application/pdf",
    "text/csv",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "text/plain"
  ];
  var ACCEPT_ATTR = ".pdf,.jpg,.jpeg,.png,.heic,.heif,.webp,.csv,.xls,.xlsx,.txt";
  var WALMART_CART_BASE = "https://www.walmart.com/sc/cart/addToCart?items=";

  function buildWalmartCartUrl(ids) {
    return WALMART_CART_BASE + ids.join(",");
  }

  function formatMoney(n) {
    return "$" + Number(n).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function isDebugCartMode(root) {
    if (root && root.getAttribute("data-dc-debug-cart") === "true") return true;
    try {
      return new URLSearchParams(window.location.search).get("dc_debug_cart") === "1";
    } catch (_) {
      return false;
    }
  }

  function fetchCartCatalog(url) {
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error("Catalog fetch failed");
      return r.json();
    });
  }

  function groupCatalogItems(catalog) {
    var order = catalog.groupOrder || [];
    var byGroup = {};
    (catalog.items || []).forEach(function (item) {
      var g = item.group || "Other";
      if (!byGroup[g]) byGroup[g] = [];
      byGroup[g].push(item);
    });
    var groups = [];
    order.forEach(function (name) {
      if (byGroup[name] && byGroup[name].length) {
        groups.push({ name: name, items: byGroup[name] });
        delete byGroup[name];
      }
    });
    Object.keys(byGroup).forEach(function (name) {
      groups.push({ name: name, items: byGroup[name] });
    });
    return groups;
  }

  function renderDefaultCart(container, catalog) {
    var activeIds = {};
    (catalog.items || []).forEach(function (item) {
      activeIds[item.id] = true;
    });

    var groupsEl = el("div", { class: "dc-cart-groups" });
    var countEl = el("span", { "data-dc-cart-count": "" });
    var totalEl = el("span", { "data-dc-cart-total": "" });
    var checkoutBtn = el("a", {
      class: "dc-btn dc-cart-checkout",
      href: buildWalmartCartUrl(Object.keys(activeIds)),
      target: "_blank",
      rel: "noopener noreferrer",
      text: "Checkout with Walmart"
    });
    var emptyMsg = el("p", {
      class: "dc-cart-empty-msg",
      style: "display:none",
      text: "Add items back to continue to Walmart, or reload the page."
    });

    function recompute() {
      var ids = [];
      var total = 0;
      var count = 0;
      (catalog.items || []).forEach(function (item) {
        if (activeIds[item.id]) {
          ids.push(item.id);
          total += item.priceValue || 0;
          count++;
        }
      });
      countEl.textContent = count + " item" + (count === 1 ? "" : "s");
      totalEl.textContent = formatMoney(total);
      if (count === 0) {
        checkoutBtn.classList.add("is-disabled");
        checkoutBtn.setAttribute("aria-disabled", "true");
        checkoutBtn.removeAttribute("href");
        emptyMsg.style.display = "block";
      } else {
        checkoutBtn.classList.remove("is-disabled");
        checkoutBtn.removeAttribute("aria-disabled");
        checkoutBtn.href = buildWalmartCartUrl(ids);
        emptyMsg.style.display = "none";
      }
    }

    groupCatalogItems(catalog).forEach(function (group) {
      var section = el("div", { class: "dc-cart-group" }, [
        el("h4", { class: "dc-cart-group-title", text: group.name })
      ]);
      var list = el("div", { class: "dc-cart-group-list" });
      group.items.forEach(function (item) {
        var row = el("div", { class: "dc-cart-item", "data-dc-cart-item": item.id }, [
          el("img", { class: "dc-cart-item-img", src: item.imageUrl, alt: "", loading: "lazy" }),
          el("div", { class: "dc-cart-item-main" }, [
            el("div", { class: "dc-cart-item-name", text: item.name }),
            el("div", { class: "dc-cart-item-cat", text: item.category })
          ]),
          el("div", { class: "dc-cart-item-price", text: item.price }),
          el("button", {
            type: "button",
            class: "dc-cart-remove",
            "aria-label": "Remove " + item.name
          }, "Remove")
        ]);
        row.querySelector(".dc-cart-remove").addEventListener("click", function () {
          delete activeIds[item.id];
          row.remove();
          if (!list.children.length) section.remove();
          recompute();
        });
        list.appendChild(row);
      });
      section.appendChild(list);
      groupsEl.appendChild(section);
    });

    var cart = el("div", { class: "dc-cart" }, [
      el("div", { class: "dc-cart-summary" }, [
        countEl,
        el("span", { text: " · Estimated total " }),
        totalEl
      ]),
      groupsEl,
      emptyMsg,
      el("div", { class: "dc-cart-footer" }, [checkoutBtn])
    ]);

    container.appendChild(cart);
    recompute();
    return cart;
  }

  /* ---------- Small helpers ---------- */
  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        if (k === "class") node.className = attrs[k];
        else if (k === "html") node.innerHTML = attrs[k];
        else if (k === "text") node.textContent = attrs[k];
        else if (k.indexOf("on") === 0 && typeof attrs[k] === "function") {
          node.addEventListener(k.slice(2), attrs[k]);
        } else if (attrs[k] !== undefined && attrs[k] !== null) {
          node.setAttribute(k, attrs[k]);
        }
      });
    }
    if (children) {
      (Array.isArray(children) ? children : [children]).forEach(function (c) {
        if (c == null) return;
        node.appendChild(typeof c === "string" ? document.createTextNode(c) : c);
      });
    }
    return node;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function fmtBytes(n) {
    if (n < 1024) return n + " B";
    if (n < 1024 * 1024) return (n / 1024).toFixed(1) + " KB";
    return (n / (1024 * 1024)).toFixed(1) + " MB";
  }

  function isValidEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v).trim());
  }

  /* ---------- Icons (inline SVG) ---------- */
  var ICONS = {
    clock: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
    gift: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="13" rx="1.5"/><path d="M12 8v13M3 12h18M7.5 8a2.5 2.5 0 1 1 1.4-4.6L12 8M16.5 8a2.5 2.5 0 1 0-1.4-4.6L12 8"/></svg>',
    cart: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 4h2l2.4 12.2A2 2 0 0 0 9.4 18h8.3a2 2 0 0 0 2-1.6L21 8H6"/><circle cx="10" cy="21" r="1.2"/><circle cx="18" cy="21" r="1.2"/></svg>',
    upload: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 16V4m0 0l-4 4m4-4l4 4"/><path d="M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"/></svg>',
    check: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5L20 7"/></svg>',
    alert: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16h.01"/></svg>',
    file: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5"/></svg>'
  };

  /* ---------- Markup ---------- */
  function render(root) {
    var endpoint = root.getAttribute("data-dc-endpoint") || "/api/dorm-concierge";
    var form = buildForm();

    var trust = el("section", { class: "dc-trust" }, [
      el("div", { class: "dc-container dc-trust-grid" }, [
        trustCard("Why we're doing this", "Project Repat has been turning your favorite t-shirts into quilts for over a decade. Dorm Concierge is our way of helping families through the most chaotic shopping week of the year."),
        trustCard("It's actually free", "We don't take a cut. We don't resell your list. We just want to be useful at move-in, and to introduce ourselves before graduation."),
        trustCard("You stay in control", "We never check out for you. We hand you a cart you can edit, swap items in, or trash entirely.")
      ])
    ]);

    var faq = el("section", { class: "dc-faq" }, [
      el("div", { class: "dc-container" }, [
        el("div", { class: "dc-section-head" }, [
          el("div", { class: "dc-eyebrow-text", text: "The honest FAQ" }),
          el("h2", { class: "dc-h2", text: "What people actually ask us." })
        ]),
        el("div", { class: "dc-faq-list" }, [
          faqItem("Is this really free?", "Yes. There's no fee, no upsell, no \"premium tier.\" If you love the cart, we'd love it if you considered a Project Repat t-shirt quilt for graduation — but that's it."),
          // faqItem("What's the turnaround?", "Usually within 24 hours on weekdays, and within 48 hours on weekends or around peak move-in weeks (mid-July through late August)."),
          faqItem("Amazon or Walmart?", "Either. Tell us your preference in the form. If you don't have one, we default to Amazon for Prime delivery speed."),
          faqItem("How do you stay on budget?", "We pick the most-reviewed item in each category that fits your budget. If we have to bump anything up, we flag it in the cart notes so you can swap it."),
          faqItem("What if my list is just a photo?", "Photos are fine. PDFs are fine. A screenshot of your school's housing portal is fine. We'll figure it out."),
          faqItem("Do you share my info?", "No. Your email and list stay with Project Repat. We don't sell or share contact info.")
        ])
      ])
    ]);

    var footnote = el("p", { class: "dc-footnote" }, [
      "Built with care by Project Repat. Questions? Email ",
      el("a", { href: "mailto:madeinusa@projectrepat.com" }, "madeinusa@projectrepat.com"),
      "."
    ]);

    var formMount = root.querySelector("[data-dc-form-mount]");
    if (formMount) {
      formMount.appendChild(form);
      wire(root, form, endpoint);
      return;
    }

    root.innerHTML = ""; // legacy embed: full client render

    // --- top eyebrow ---
    var eyebrow = el("div", { class: "dc-eyebrow" }, [
      "A free service from ",
      el("strong", null, "Project Repat"),
      " · Class of 2026"
    ]);

    // --- hero ---
    var hero = el("section", { class: "dc-hero" }, [
      el("div", { class: "dc-container dc-hero-grid" }, [
        el("div", null, [
          el("span", { class: "dc-pretitle" }, [
            el("span", { class: "dc-dot" }),
            "Dorm Concierge"
          ]),
          el("h1", { class: "dc-h1", html: 'Skip the dorm shopping <em>chaos.</em>' }),
          el("p", {
            class: "dc-sub",
            text:
              "Send us your school's packing list and we'll build you a one-click Amazon or Walmart cart. No app. No upsell. Just a real person at Project Repat doing the boring part for you."
          }),
          el("div", { class: "dc-hero-meta" }, [
            //metaItem(ICONS.clock, "Cart back in ~24 hours"),
            metaItem(ICONS.gift, "100% free, no obligation"),
            metaItem(ICONS.cart, "Amazon or Walmart — your call")
          ])
        ]),
        el("aside", { class: "dc-hero-card", "aria-label": "How it works" }, [
          el("ol", { class: "dc-stepline" }, [
            stepLi("Send the list", "Upload the PDF, snap a photo, or paste it in."),
            stepLi("We build the cart", "A human at Project Repat picks each item to your budget."),
            stepLi("One-click checkout", "We send you a share-cart link. You review, edit, and buy.")
          ])
        ])
      ])
    ]);

    // --- the form section ---
    var section = el("section", { class: "dc-section", id: "dc-form" }, [
      el("div", { class: "dc-container" }, [
        el("div", { class: "dc-section-head" }, [
          el("div", { class: "dc-eyebrow-text", text: "Tell us what you need" }),
          el("h2", { class: "dc-h2", text: "Your dorm, sorted in one short form." }),
          el("p", {
            text:
              "We just need a few basics and your school's packing list. We'll take it from there and email you a live cart link."
          })
        ]),
        form
      ])
    ]);

    root.appendChild(eyebrow);
    root.appendChild(hero);
    root.appendChild(section);
    root.appendChild(trust);
    root.appendChild(faq);
    root.appendChild(footnote);

    wire(root, form, endpoint);
  }

  function metaItem(svg, label) {
    return el("span", { class: "dc-hero-meta-item" }, [
      el("span", { html: svg, "aria-hidden": "true" }),
      el("span", { text: label })
    ]);
  }
  function stepLi(title, body) {
    return el("li", null, [
      el("h4", { text: title }),
      el("p", { text: body })
    ]);
  }
  function trustCard(title, body) {
    return el("div", { class: "dc-trust-card" }, [
      el("h4", { text: title }),
      el("p", { text: body })
    ]);
  }
  function faqItem(q, a) {
    return el("details", { class: "dc-faq-item" }, [
      el("summary", { text: q }),
      el("div", { class: "dc-faq-body", text: a })
    ]);
  }

  /* ---------- Form markup ---------- */
  function buildForm() {
    var form = el("form", { class: "dc-form-wrap", novalidate: "", enctype: "multipart/form-data" });

    // Family
    form.appendChild(fieldset("Who's this for?",
      "Parents, students, aunts, uncles — anyone helping with move-in.", [
      row2(
        field({ id: "parentName", label: "Your name", required: true, autocomplete: "name" }),
        field({ id: "studentName", label: "Student's first name", required: true })
      ),
      row2(
        field({ id: "email", label: "Email", required: true, type: "email", autocomplete: "email", hint: "We'll send the cart link here." }),
        field({ id: "phone", label: "Phone (optional)", type: "tel", autocomplete: "tel", hint: "Only if you'd prefer a text when the cart is ready." })
      )
    ]));

    // School
    form.appendChild(fieldset("The school",
      "Most schools publish a recommended packing list. If you have it, great. If not, we'll use the school's housing rules.", [
      row2(
        field({ id: "school", label: "College or university", required: true }),
        field({ id: "moveInDate", label: "Move-in date (optional)", type: "date", hint: "Helps us prioritize around peak move-in weeks." })
      ),
      field({ id: "roomType", label: "Room type (optional)", control: "select", options: [
        ["", "Choose one..."],
        ["traditional", "Traditional dorm (shared bathroom)"],
        ["suite", "Suite-style (shared with a few)"],
        ["apartment", "On-campus apartment"],
        ["unknown", "Not sure yet"]
      ] })
    ]));

    // Preferences
    form.appendChild(fieldset("Your preferences",
      "Tell us how to shop. We'll match your taste, not ours.", [
      pillField("retailer", "Preferred retailer", [
        { value: "amazon", label: "Amazon" },
        { value: "walmart", label: "Walmart" },
        { value: "either", label: "Either is fine" }
      ], "either", true),
      row2(
        field({ id: "budget", label: "Total budget (USD, optional)", type: "number", min: 50, step: 25, hint: "Most families land between $400–$1,200." }),
        field({ id: "style", label: "Color / style vibe", placeholder: "e.g. warm neutrals, sage green, navy + cream", hint: "Optional — helps us pick bedding and decor." })
      ),
      field({
        id: "notes",
        label: "Anything we should know?",
        control: "textarea",
        placeholder:
          "Allergies, must-haves, brands to avoid, an older sibling's hand-me-downs, religious or dietary needs, etc."
      })
    ]));

    // Packing list — default cart, upload, or paste
    form.appendChild(fieldset("The packing list",
      "Choose the default cart, send us your school's list, or both — but pick at least one.", [
      defaultListOption(),
      el("p", { class: "dc-method-divider", text: "and / or send us your list" }),
      el("div", { class: "dc-list-methods", "data-dc-list-methods": "" }, [
        dropzone(),
        field({
          id: "pastedList",
          label: "Paste your packing list or email",
          control: "textarea",
          placeholder: "Paste the full packing list, housing email, or housing portal text here…"
        })
      ])
    ]));

    // Consent + submit
    var consent = el("label", { class: "dc-checkrow" }, [
      el("input", { type: "checkbox", id: "dc-consent", required: "" }),
      el("span", { html:
        'I\'m okay with Project Repat emailing me my cart and the occasional dorm tip. ' +
        'No spam, unsubscribe anytime. <a href="https://www.projectrepat.com/policies/privacy-policy" target="_blank" rel="noopener">Privacy policy</a>.'
      })
    ]);
    form.appendChild(consent);

    var actions = el("div", { class: "dc-actions" }, [
      el("p", { class: "dc-meta-text", text: "Most lists are turned around within a few days." }),
      el("button", { type: "submit", class: "dc-btn", "data-dc-submit": "" }, [
        el("span", { class: "dc-spinner", "aria-hidden": "true" }),
        el("span", { class: "dc-btn-label", "data-dc-btn-label": "", text: "Send my list" })
      ])
    ]);
    form.appendChild(actions);

    // progress + form-level error
    var progress = el("div", { class: "dc-progress", role: "progressbar", "aria-label": "Upload progress" }, [
      el("div", { class: "dc-progress-bar" })
    ]);
    form.appendChild(progress);

    var formErr = el("div", {
      class: "dc-error", style: "display:none;margin-top:14px;font-size:13px;color:var(--dc-error);",
      "data-dc-formerr": ""
    });
    form.appendChild(formErr);

    return form;
  }

  function fieldset(legendText, helpText, children) {
    return el("fieldset", { class: "dc-fieldset" }, [
      el("legend", { text: legendText }),
      el("p", { class: "dc-help", text: helpText })
    ].concat(children));
  }
  function row2(a, b) { return el("div", { class: "dc-row" }, [a, b]); }
  function field(opts) {
    var wrap = el("div", { class: "dc-field" });
    var labelText = opts.label;
    var label = el("label", { for: opts.id, html: escapeHtml(labelText) + (opts.required ? ' <span class="dc-req">*</span>' : '') });
    wrap.appendChild(label);

    var control;
    if (opts.control === "select") {
      control = el("select", {
        id: opts.id, name: opts.id, required: opts.required ? "" : null
      });
      (opts.options || []).forEach(function (op) {
        var o = el("option", { value: op[0] }, op[1]);
        control.appendChild(o);
      });
    } else if (opts.control === "textarea") {
      control = el("textarea", {
        id: opts.id, name: opts.id,
        placeholder: opts.placeholder || "",
        required: opts.required ? "" : null
      });
    } else {
      control = el("input", {
        id: opts.id, name: opts.id,
        type: opts.type || "text",
        autocomplete: opts.autocomplete || "off",
        placeholder: opts.placeholder || "",
        required: opts.required ? "" : null,
        min: opts.min, step: opts.step
      });
    }
    wrap.appendChild(control);

    if (opts.hint) wrap.appendChild(el("span", { class: "dc-hint", text: opts.hint }));
    wrap.appendChild(el("span", { class: "dc-error", "data-dc-err": "" }));
    return wrap;
  }
  function pillField(name, label, options, defaultVal, required) {
    var wrap = el("div", { class: "dc-field" });
    wrap.appendChild(el("label", { html: escapeHtml(label) + (required ? ' <span class="dc-req">*</span>' : '') }));
    var group = el("div", { class: "dc-pillgroup", role: "radiogroup", "aria-label": label });
    options.forEach(function (o) {
      var input = el("input", { type: "radio", name: name, value: o.value, required: required ? "" : null });
      if (o.value === defaultVal) input.checked = true;
      var pill = el("label", { class: "dc-pill" + (o.value === defaultVal ? " is-checked" : "") }, [
        input, el("span", { text: o.label })
      ]);
      input.addEventListener("change", function () {
        group.querySelectorAll(".dc-pill").forEach(function (p) { p.classList.remove("is-checked"); });
        if (input.checked) pill.classList.add("is-checked");
      });
      group.appendChild(pill);
    });
    wrap.appendChild(group);
    wrap.appendChild(el("span", { class: "dc-error", "data-dc-err": "" }));
    return wrap;
  }
  function defaultListOption() {
    return el("label", { class: "dc-checkrow dc-default-list", "data-dc-default-list": "" }, [
      el("input", { type: "checkbox", id: "useDefaultList", name: "useDefaultList", value: "true" }),
      el("span", null, [
        el("strong", { text: "Show me a default dorm packing list cart" }),
        el("span", {
          class: "dc-default-list-sub",
          text: " Get a ready-made Walmart cart built for typical dorm move-ins — you can still send us your school's list for us to review."
        })
      ])
    ]);
  }
  function dropzone() {
    var wrap = el("div", { class: "dc-field" });
    var drop = el("label", { class: "dc-drop", "data-dc-drop": "" }, [
      el("span", { html: ICONS.upload, "aria-hidden": "true" }),
      el("div", { class: "dc-drop-title", text: "Drag files here or click to upload" }),
      el("div", { class: "dc-drop-sub", text: "PDF · JPG · PNG · HEIC · CSV · XLSX · TXT · up to " + MAX_FILES + " files" }),
      el("input", { type: "file", id: "files", name: "files", multiple: "", accept: ACCEPT_ATTR })
    ]);
    var list = el("ul", { class: "dc-filelist", "data-dc-filelist": "" });
    wrap.appendChild(drop);
    wrap.appendChild(list);
    wrap.appendChild(el("span", { class: "dc-error", "data-dc-err": "" }));
    return wrap;
  }

  function getSubmitLabel(useDefaultList, hasFiles, hasPaste) {
    var hasCustom = hasFiles || hasPaste;
    if (useDefaultList && hasCustom) {
      if (hasFiles && hasPaste) return "Get default cart & send list + paste";
      return "Get default cart & send my list";
    }
    if (useDefaultList) return "Show me the default cart";
    if (hasFiles && hasPaste) return "Send my list & pasted text";
    if (hasPaste) return "Send my pasted list";
    return "Send my list";
  }

  /* ---------- Wiring: validation + upload ---------- */
  function wire(root, form, endpoint) {
    var fileInput = form.querySelector('input[type="file"]');
    var dropEl = form.querySelector('[data-dc-drop]');
    var fileListEl = form.querySelector('[data-dc-filelist]');
    var pasteInput = form.querySelector("#pastedList");
    var defaultListCheckbox = form.querySelector("#useDefaultList");
    var submitBtn = form.querySelector("[data-dc-submit]");
    var btnLabelEl = form.querySelector("[data-dc-btn-label]");
    var progressEl = form.querySelector('.dc-progress');
    var progressBar = form.querySelector('.dc-progress-bar');
    var formErrEl = form.querySelector('[data-dc-formerr]');
    var cartUrl = root.getAttribute("data-dc-cart-url");
    var catalogPromise = cartUrl
      ? fetchCartCatalog(cartUrl).catch(function () { return null; })
      : Promise.resolve(null);
    var debugMode = isDebugCartMode(root);

    // selected files held in widget state (don't use storage)
    var files = [];

    function hasPastedList() {
      return pasteInput && String(pasteInput.value || "").trim().length > 0;
    }

    function useDefaultList() {
      return defaultListCheckbox && defaultListCheckbox.checked;
    }

    function syncListMethodUi() {
      if (btnLabelEl) {
        btnLabelEl.textContent = getSubmitLabel(useDefaultList(), files.length > 0, hasPastedList());
      }
    }

    if (defaultListCheckbox) {
      defaultListCheckbox.addEventListener("change", syncListMethodUi);
    }

    if (pasteInput) {
      pasteInput.addEventListener("input", syncListMethodUi);
    }

    function renderFiles() {
      fileListEl.innerHTML = "";
      files.forEach(function (f, i) {
        var li = el("li", null, [
          el("span", { html: ICONS.file, "aria-hidden": "true" }),
          el("span", { class: "dc-fname", text: f.name }),
          el("span", { class: "dc-fsize", text: fmtBytes(f.size) }),
          el("button", {
            type: "button",
            "aria-label": "Remove " + f.name,
            onclick: function () { files.splice(i, 1); renderFiles(); syncListMethodUi(); }
          }, "Remove")
        ]);
        fileListEl.appendChild(li);
      });
    }

    function addFiles(incoming) {
      formErrEl.style.display = "none";
      for (var i = 0; i < incoming.length; i++) {
        var f = incoming[i];
        if (files.length >= MAX_FILES) {
          showFormError("You can attach up to " + MAX_FILES + " files. Remove one to add another.");
          break;
        }
        if (f.size > MAX_FILE_BYTES) {
          showFormError(f.name + " is over " + (MAX_FILE_BYTES / 1024 / 1024) + " MB. Try a smaller file or split the list.");
          continue;
        }
        // Accept by extension OR mime, since some browsers report blank type for HEIC.
        if (f.type && ACCEPTED_TYPES.indexOf(f.type) === -1) {
          var ext = f.name.split(".").pop().toLowerCase();
          if (ACCEPT_ATTR.indexOf("." + ext) === -1) {
            showFormError(f.name + " isn't a supported file type.");
            continue;
          }
        }
        files.push(f);
      }
      renderFiles();
      syncListMethodUi();
    }

    fileInput.addEventListener("change", function (e) {
      addFiles(e.target.files);
      // reset so re-selecting the same file fires change
      fileInput.value = "";
    });

    // drag/drop
    ["dragenter", "dragover"].forEach(function (ev) {
      dropEl.addEventListener(ev, function (e) { e.preventDefault(); dropEl.classList.add("is-drag"); });
    });
    ["dragleave", "drop"].forEach(function (ev) {
      dropEl.addEventListener(ev, function (e) { e.preventDefault(); dropEl.classList.remove("is-drag"); });
    });
    dropEl.addEventListener("drop", function (e) {
      if (e.dataTransfer && e.dataTransfer.files) addFiles(e.dataTransfer.files);
    });

    function showFormError(msg) {
      formErrEl.textContent = msg;
      formErrEl.style.display = "block";
    }
    function clearFieldErrors() {
      form.querySelectorAll(".dc-field.dc-invalid").forEach(function (n) { n.classList.remove("dc-invalid"); });
      form.querySelectorAll("[data-dc-err]").forEach(function (n) { n.textContent = ""; });
      formErrEl.style.display = "none";
    }
    function setFieldError(id, msg) {
      var inp = form.querySelector("#" + id) || form.querySelector('[name="' + id + '"]');
      if (!inp) return;
      var wrap = inp.closest(".dc-field");
      if (wrap) {
        wrap.classList.add("dc-invalid");
        var errSpan = wrap.querySelector("[data-dc-err]");
        if (errSpan) errSpan.textContent = msg;
      }
    }

    function validate() {
      clearFieldErrors();
      var ok = true;
      var required = ["parentName", "studentName", "email", "school"];
      required.forEach(function (id) {
        var inp = form.querySelector("#" + id);
        if (!inp || !String(inp.value || "").trim()) {
          setFieldError(id, "This field is required.");
          ok = false;
        }
      });
      var emailInp = form.querySelector("#email");
      if (emailInp.value && !isValidEmail(emailInp.value)) {
        setFieldError("email", "That email doesn't look right.");
        ok = false;
      }
      var budgetInp = form.querySelector("#budget");
      if (budgetInp.value && (isNaN(+budgetInp.value) || +budgetInp.value < 50)) {
        setFieldError("budget", "Pick a budget of $50 or more so we have something to work with.");
        ok = false;
      }
      var retailerChecked = form.querySelector('input[name="retailer"]:checked');
      if (!retailerChecked) {
        setFieldError("retailer", "Pick a retailer.");
        ok = false;
      }
      var consent = form.querySelector("#dc-consent");
      if (!consent.checked) {
        showFormError("Please check the consent box so we can email you the cart.");
        ok = false;
      }
      var isDefaultList = useDefaultList();
      var pasted = hasPastedList();
      var hasCustomList = files.length > 0 || pasted;
      if (!isDefaultList && !hasCustomList) {
        setFieldError("files", "Choose the default cart, upload a file, paste your list, or any combination.");
        if (pasteInput) {
          var pasteWrap = pasteInput.closest(".dc-field");
          if (pasteWrap) pasteWrap.classList.add("dc-invalid");
        }
        ok = false;
      }
      if (!ok && !formErrEl.textContent) {
        showFormError("Please fix the highlighted fields above.");
      }
      return ok;
    }

    function setLoading(loading) {
      if (loading) {
        submitBtn.classList.add("is-loading");
        submitBtn.disabled = true;
        progressEl.classList.add("is-active");
        progressBar.style.width = "0%";
      } else {
        submitBtn.classList.remove("is-loading");
        submitBtn.disabled = false;
      }
    }

    /* swap form section content for state */
    function showState(kind, opts) {
      opts = opts || {};
      var section = form.closest(".dc-section");
      var icon = kind === "success" ? ICONS.check : ICONS.alert;
      var stateClass = "dc-state dc-state-" + kind + (opts.defaultCart ? " dc-state-cart" : "");
      var state = el("div", { class: stateClass }, [
        el("div", { class: "dc-state-icon", html: icon, "aria-hidden": "true" }),
        el("h3", { text: opts.title }),
        el("p", { text: opts.body })
      ]);
      if (opts.ref) {
        state.appendChild(el("p", null, [
          el("span", { class: "dc-ref", text: "Reference: " + opts.ref })
        ]));
      }
      if (opts.defaultCart) {
        var cartMount = el("div", { class: "dc-cart-mount", "data-dc-cart-mount": "" });
        state.appendChild(cartMount);
        catalogPromise.then(function (catalog) {
          if (!catalog) {
            cartMount.appendChild(el("p", {
              class: "dc-cart-load-err",
              text: "We couldn't load the default cart. Please refresh and try again."
            }));
            return;
          }
          renderDefaultCart(cartMount, catalog);
        });
      } else if (opts.cta) {
        state.appendChild(el("div", { class: "dc-state-cta" }, [
          el("a", {
            href: opts.cta.href,
            class: "dc-btn",
            target: "_blank",
            rel: "noopener noreferrer",
            text: opts.cta.label
          })
        ]));
      }
      if (kind === "error") {
        state.appendChild(el("button", {
          type: "button",
          class: "dc-btn dc-btn-ghost",
          onclick: function () { window.location.reload(); }
        }, "Try again"));
      }
      // replace form content
      var head = section.querySelector(".dc-section-head");
      section.querySelector(".dc-container").innerHTML = "";
      section.querySelector(".dc-container").appendChild(head);
      section.querySelector(".dc-container").appendChild(state);
      hideCartPreview();
      // scroll the state into view politely
      state.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    function hideCartPreview() {
      var existing = form.parentNode && form.parentNode.querySelector("[data-dc-cart-preview]");
      if (existing) existing.remove();
    }

    function openCartPreview() {
      catalogPromise.then(function (catalog) {
        if (!catalog) {
          showFormError("Could not load the default cart catalog. Please refresh.");
          return;
        }
        hideCartPreview();
        var preview = el("div", { class: "dc-cart-preview", "data-dc-cart-preview": "" }, [
          el("div", { class: "dc-debug-banner", text: "Debug preview — form not submitted" }),
          el("button", {
            type: "button",
            class: "dc-btn dc-btn-ghost dc-cart-preview-back",
            onclick: hideCartPreview
          }, "Back to form")
        ]);
        renderDefaultCart(preview, catalog);
        form.parentNode.insertBefore(preview, form.nextSibling);
        preview.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!validate()) return;

      var isDefaultList = useDefaultList();
      var pastedText = pasteInput ? String(pasteInput.value || "").trim() : "";
      var hasCustomList = files.length > 0 || pastedText.length > 0;
      var fd = new FormData();
      // text fields
      ["parentName", "studentName", "email", "phone", "school", "moveInDate", "roomType", "budget", "style", "notes"].forEach(function (id) {
        var inp = form.querySelector("#" + id);
        if (inp && inp.value) fd.append(id, inp.value);
      });
      var retailer = form.querySelector('input[name="retailer"]:checked');
      if (retailer) fd.append("retailer", retailer.value);
      fd.append("consent", form.querySelector("#dc-consent").checked ? "true" : "false");
      fd.append("listMethod", isDefaultList && hasCustomList ? "default+custom" : isDefaultList ? "default" : "custom");
      fd.append("useDefaultList", isDefaultList ? "true" : "false");
      if (pastedText) fd.append("pastedList", pastedText);
      // page context (handy for the receiving end)
      fd.append("sourceUrl", typeof window !== "undefined" ? window.location.href : "");
      fd.append("submittedAt", new Date().toISOString());
      // files — single field name "files", multiple values
      files.forEach(function (f) { fd.append("files", f, f.name); });
      if (pastedText) {
        var pastedFile = new File([pastedText], "pasted-packing-list.txt", { type: "text/plain" });
        fd.append("files", pastedFile, pastedFile.name);
      }

      setLoading(true);

      // Use XHR so we get upload progress events; fetch lacks upload progress.
      var xhr = new XMLHttpRequest();
      xhr.open("POST", endpoint, true);
      xhr.upload.addEventListener("progress", function (ev) {
        if (ev.lengthComputable) {
          var pct = Math.round((ev.loaded / ev.total) * 100);
          progressBar.style.width = pct + "%";
        }
      });
      xhr.onreadystatechange = function () {
        if (xhr.readyState !== 4) return;
        setLoading(false);
        var data = null;
        try { data = JSON.parse(xhr.responseText); } catch (_) {}
        if (xhr.status >= 200 && xhr.status < 300 && data && data.success) {
          var parentName = form.querySelector("#parentName").value || "friend";
          var emailVal = form.querySelector("#email").value;
          var successOpts = {
            title: isDefaultList && hasCustomList ? "You're all set." : isDefaultList ? "Your default cart is ready." : "We got it.",
            body: isDefaultList && hasCustomList
              ? "Thanks, " + parentName + ". Here's your ready-made Walmart cart — and our team is reviewing the list you sent. We'll email you at " + emailVal + " once we're done."
              : isDefaultList
              ? "Thanks, " + parentName + ". Review your dorm cart below — remove anything you don't need, then check out on Walmart when you're ready."
              : "Thanks, " + parentName +
                ". A team member at Project Repat is on this. You'll get an email at " +
                emailVal +
                " with your cart link.",
            ref: data.id || data.reference
          };
          if (isDefaultList) {
            successOpts.defaultCart = true;
          }
          showState("success", successOpts);
        } else {
          var msg = (data && (data.error || data.message)) || "Something went wrong on our end. Please try again, or email madeinusa@projectrepat.com.";
          showState("error", {
            title: "We couldn't send that.",
            body: msg
          });
        }
      };
      xhr.onerror = function () {
        setLoading(false);
        showState("error", {
          title: "Network hiccup.",
          body: "Your connection dropped before we could send the form. Please try again."
        });
      };
      // The browser sets the multipart boundary automatically when you pass FormData.
      xhr.send(fd);
    });

    // also: fetch alternative is exposed for environments that prefer it
    form.__dcSubmitFetch = function (fd) {
      return fetch(endpoint, { method: "POST", body: fd });
    };

    if (debugMode) {
      var defaultListEl = form.querySelector("[data-dc-default-list]");
      if (defaultListEl && defaultListEl.parentNode) {
        var previewWrap = el("div", { class: "dc-debug-actions" });
        previewWrap.appendChild(el("button", {
          type: "button",
          class: "dc-btn dc-btn-ghost dc-debug-preview-btn",
          onclick: openCartPreview
        }, "Preview default cart"));
        defaultListEl.parentNode.insertBefore(previewWrap, defaultListEl.nextSibling);
      }
      var actionsEl = form.querySelector(".dc-actions");
      if (actionsEl) {
        actionsEl.appendChild(el("button", {
          type: "button",
          class: "dc-btn dc-btn-ghost dc-debug-skip-btn",
          onclick: openCartPreview
        }, "Skip submit & preview cart"));
      }
    }

    syncListMethodUi();
  }

  /* ---------- Public API ---------- */
  function mountAll(selector) {
    var roots = document.querySelectorAll(selector || ".dc-app");
    roots.forEach(function (r) {
      if (r.getAttribute("data-dc-mounted") === "1") return;
      r.setAttribute("data-dc-mounted", "1");
      try { render(r); }
      catch (err) {
        // eslint-disable-next-line no-console
        console.error("[DormConcierge] render failed", err);
      }
    });
  }

  global.DormConcierge = { mountAll: mountAll, render: render };
})(typeof window !== "undefined" ? window : this);
